<template lang="pug">
  .component-create-entity-button
    ModalReveal
      a.fa-stack.fa-lg(slot="trigger")
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      EditReportingType
</template>
<script type="text/babel">
  import ModalReveal from '../../foundation/ModalReveal'
  import EditReportingType from '../../../../pages/backoffice/EditReportingType'
  export default {
    name: 'CreateEntityButton',
    components: {EditReportingType, ModalReveal},
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateReportingTypeButtonModal.vue?a6b07e6e